/**
 * Static class to watch over all decorated `Persistant` or `Selectable` instances.
 * Notifies subscribers when the instance of specifed `type` is created or disposed.
 */
export class Watcher {
    constructor() { }
    static notify_created(value) {
        Watcher._subscriptions.forEach(({ subscriber, watching }) => {
            if (value instanceof watching) {
                subscriber.on_object_created(value);
            }
        });
        Watcher._disposable_storage.add(value);
    }
    static notify_disposed(value) {
        Watcher._subscriptions.forEach(({ subscriber, watching }) => {
            if (value instanceof watching) {
                subscriber.on_object_disposed(value);
            }
        });
        Watcher._disposable_storage.delete(value);
    }
    static clear() {
        Watcher._subscriptions.clear();
        Watcher._disposable_storage.clear();
    }
}
Watcher._subscriptions = new Set();
Watcher._disposable_storage = new Set();
Watcher.subscriptions = {
    add: (subsciption) => {
        Watcher._subscriptions.add(subsciption);
        const { subscriber, watching } = subsciption;
        for (const value of Watcher._disposable_storage) {
            if (value instanceof watching) {
                subscriber.on_object_created(value);
            }
        }
    },
    remove: (subscriber) => {
        Watcher._subscriptions.forEach(subscription => {
            if (subscription.subscriber === subscriber) {
                Watcher._subscriptions.delete(subscription);
            }
        });
    }
};
//# sourceMappingURL=Watcher.js.map